import { Field } from 'formik'
import type { ChangeEvent } from 'react'

type TextInputProps = {
  id?: string
  type?: 'text' | 'email' | 'number'
  placeholder?: string
  defaultValue?: string
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onSubmit?: () => void
  onKeyDown?: (e: any) => any
  name?: string
  readOnly?: boolean
  min?: number
  max?: number
  hasError?: boolean
  className?: string
}

export default function TextInput({
  id,
  type = 'text',
  placeholder,
  defaultValue,
  value,
  onChange,
  onSubmit,
  onKeyDown,
  name,
  readOnly,
  min,
  max,
  hasError,
  className,
  ...props
}: TextInputProps) {
  let additionalClassName =
    (className ? `${className} ` : '') +
    'border leading-none rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-gray-900 bg-white-100'
  if (readOnly)
    additionalClassName += ' text-gray-500 bg-gray-100 border-gray-100'
  else if (hasError) additionalClassName += ' border-red-300 bg-white-100'
  else additionalClassName += ' text-gray-900 bg-white-100 border-gray-300'

  if (name) {
    return (
      <Field
        name={name}
        id={name}
        aria-labelledby={name}
        type={type}
        className={additionalClassName}
        placeholder={placeholder}
        readOnly={readOnly}
        defaultValue={defaultValue}
        onKeyDown={onKeyDown}
        {...props}
      />
    )
  }
  return (
    <input
      id={id}
      aria-labelledby={id}
      type={type}
      className={additionalClassName}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      readOnly={readOnly}
      min={min}
      max={max}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onSubmit) {
          onSubmit()
        }
      }}
    />
  )
}
